import { render, staticRenderFns } from "./PH15L.vue?vue&type=template&id=46254887&scoped=true"
import script from "./PH15L.vue?vue&type=script&lang=js"
export * from "./PH15L.vue?vue&type=script&lang=js"
import style0 from "./PH15L.vue?vue&type=style&index=0&id=46254887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46254887",
  null
  
)

export default component.exports